const cache = {};
const proxify = (target, name, bus) => {
    const save = () => localStorage.setItem(name, JSON.stringify(target));
    return new Proxy(target, {
        get: (t, key) => t[key],
        set: (t, key, value) => {
            const old = t[key];
            if (old !== value) {
                t[key] = value;
                save();
                bus?.emit('change', t);
            }
            return true;
        },
        defineProperty: (t, key) => {
            delete t[key];
            save();
            return true;
        },
    });
};
export const ReactiveLocalStorage = (name, bus) => {
    if (!cache[name]) {
        const data = localStorage.getItem(name) || '{}';
        cache[name] = proxify(JSON.parse(data), name, bus);
    }
    return cache[name];
};
//# sourceMappingURL=LocalStorage.js.map